
export const navigateOnFailures = (
  isAuthenticated: boolean | undefined,
  authenticationRequired: boolean | undefined,
) => {
  if (isAuthenticated === false) {
    if (authenticationRequired) {
      window.location.href = `https://base-dev.mindx.edu.vn/login?callbackUrl=${window.location.href}`;
    }
  }
};
